module.exports = __webpack_public_path__ + "static/media/Shabnam-Thin.84365f98.woff";